export default {
    INVENTORY(state, items) {
        state.items = items
    }
}